import Header from "../components/Header";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { userLogoutThunk } from "../modules/userReducer";

const HeaderContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.user);

  const handleLoginClick = useCallback(() => {
    history.push("/login");
  }, [history]);

  const handleLogoutClick = useCallback(() => {
    dispatch(userLogoutThunk());
    history.push("/");
  }, [history, dispatch]);

  return (
    <Header
      user={user}
      onLoginClick={handleLoginClick}
      onLogoutClick={handleLogoutClick}
    />
  );
};

export default HeaderContainer;
